import EventView from '../../../../shared/services/sub/events/EventView';

export default function EventViewSection() {
  return <EventView />;
}
